import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '@chilipiper/api-client/src/context'

const userAvailabilityQueryKeys = {
  meetingAttempt: (tenantId: string, meetingAttemptId: string) => [
    'meeting-attempt',
    tenantId,
    meetingAttemptId,
  ],
}
export const useMeetingAttempt = ({
  tenantId,
  meetingAttemptId,
}: {
  meetingAttemptId: string
  tenantId: string
}) => {
  const { userAvailabilityV3 } = useApiClient()
  return useQuery({
    queryKey: userAvailabilityQueryKeys.meetingAttempt(tenantId, meetingAttemptId),
    queryFn: () => userAvailabilityV3.getMeetingAttemptV3(tenantId, meetingAttemptId),
  })
}
